import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IUseSource {
  data: string[]
}

export const useSource = ({ data }: IUseSource) => {
  const source = useMemo(() => {
    return new Crud({
      fetcher: new Static(
        data.map((el) => {
          return { label: el, value: el }
        })
      ),
      defaultPaging: {
        page: 0,
        pageSize: data.length,
      },
      keyField: 'value',
    })
  }, [data])

  return { source }
}
